import type { 
  PutCommentsByIdData,
  PutCommentsByIdResponse,

  DeleteCommentsByIdData,
  DeleteCommentsByIdResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getCommentApiModule(affiliatesApi: AxiosInstance) {
  return {
    updateComment(id: string, data: PutCommentsByIdData['body']) {
      return affiliatesApi.put<PutCommentsByIdResponse>(`/comments/${id}`, data);
    },
    deleteComment(id: string) {
      return affiliatesApi.delete<DeleteCommentsByIdResponse>(`/comments/${id}`);
    },
  }
}